<template>
  <div>
    <vx-form layout="h" v-slot="{handleSubmit}">
      <form-item required hideLabel class="mb-5">
        <vs-input 
          class="w-full" 
          v-model="username" 
          icon-no-border
          icon="iconfont icon-user"
          icon-pack="feather"
          placeholder="账号"
          @keypress.enter="handleSubmit(loginJWT)"
        />
      </form-item>
      <form-item required hideLabel class="mb-5">
        <vs-input 
          type="password"
          name="password"
          icon-no-border
          icon="iconfont icon-lock"
          icon-pack="feather"
          placeholder="密码"
          v-model="password"
          class="w-full"
          @keypress.enter="handleSubmit(loginJWT)"
        />
      </form-item>
      <div class="flex flex-wrap justify-between my-5">
          <vs-checkbox v-model="checkbox_remember_me" class="mb-3">记住我</vs-checkbox>
          <router-link to="/pages/forgot-password">忘记密码?</router-link>
      </div>
      <div class="flex flex-wrap justify-between mb-3">
        <vs-button  type="border" @click="registerUser">注册</vs-button>
        <vs-button @click="handleSubmit(loginJWT)">登录</vs-button>
      </div>
    </vx-form>

  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      checkbox_remember_me: true
    }
  },
  computed: {
    isAdminLogin() {
      return this.$route.path === '/pages/login/admin'
    }
  },
  methods: {
    async loginJWT() {

      if (await this.$s.auth.isLogin()) return

      // Loading
      this.$vs.loading()

      const payload = {
        username: this.username,
        password: this.password,
        remember: this.checkbox_remember_me,
        admin: this.isAdminLogin,
      }

      this.$s.auth.loginLocal(payload)
        .then(user => { 
          this.$vs.loading.close() 
          this.$s.auth.loginSuccess(user, this)
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: '登录失败',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    async registerUser() {
      if (await this.$s.auth.isLogin()) return

      this.$router.push('/pages/register').catch(() => {})
    }
  }
}

</script>

